/**
 * Created by 唐亦慧 on 2017/8/29.
 */

import {config, request, objectSerial} from 'Utils';


//获取全局变量列表
export function globalVarList(param) {
	return request(`${config.server}/api/v1/dms/globalVariable/list`,{
		method: 'post',
		body: param
	});
}


//新增或修改全局变量
/*
*  {
 active (integer, optional): 启用状态（1启用，0禁用） ,
 description (string, optional): 描述 ,
 id (integer, optional): 主键ID ,
 name (string, optional): 变量名称 ,
 sKey (string, optional): 变量key ,
 value (string, optional): 变量value
 }
* */
export function saveOrUpdate(param) {
	return request(`${config.server}/api/v1/dms/globalVariable/saveOrUpdate`,{
		method: 'post',
		body: param
	});
}


//查看变量详情
export function globalVarDetail(param) {
	return request(`${config.server}/api/v1/dms/globalVariable/detail?${objectSerial(param)}`,{method: 'post'});
}


//删除变量
/*
*  {
 id (integer, optional): 主键ID ,
 }
* */
export function globalVarDelete(param) {
	return request(`${config.server}/api/v1/dms/globalVariable/delete?${objectSerial(param)}`,{method: 'post'});
}



// WEBPACK FOOTER //
// ./src/service/globalVar/index.js